<template>
        <div class="max-w-content">
            <div class="header-branch-box"><p class="title">{{componentTitle}}</p></div>
            <input type="text" placeholder="Введите название ветки" v-model="branch.title" class="form-control large-size-inp branch-title">
            <p class="branch-sub-title">Добавьте чек-листы в ветку</p>
            <div class="check-lists checkbox-view can-drag large-indent">

                <branches-list :branchList="commonBranch" :draggable="false" :view="true" v-model="values" :list-click="false"></branches-list>

                <span v-show="$_.isEmpty(activeList)" @click="closeClick" title="Закрыть" class="js-hide-branch-component">
                    <icon-base width="14" height="14" viewBox="0 0 14 14"><icon-close/></icon-base>
                </span>
            </div>

            <div class="branch-btns-box center" :class="loading ? 'disabled' : ''">
                <div class="sub-box">
                    <a href type="button" @click.prevent="saveClick" class="btn">{{controlType === COPY_BRANCH ? 'Создать ветку' : 'Сохранить'}}</a>
                </div>
            </div>
        </div>
</template>

<script>
    import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
    import BranchesList from "./BranchesList";
    import CompleteComponent from "../common/CompleteComponent";
    import {EDIT_BRANCH, COPY_BRANCH, CREATE_BRANCH, NOTIFICATION_WARNING} from '../../constants/common'
    import IconBase from "../common/IconBase";
    import IconClose from "../common/icons/IconClose";


    export default {
        name: 'create-branch',
        components: {
            IconBase,
            IconClose,
            BranchesList,
        },
        props: {
            //post: Object,
        },
        computed: {
            ...mapState({
                controlType: state => state.checkLists.controlType,
                commonBranch: state => state.checkLists.common,
                activeBranch: state => state.checkLists.activeBranch,
                activeList: state => state.checkLists.activeList
            }),
            ...mapGetters('checkLists', [
                'getPersonalBranch'
            ]),
            getBranch() {
                return this.$store.state.checkLists.personal.find((x => x.id === this.activeBranch))
            },
            componentTitle() {
                switch(this.controlType) {
                    case EDIT_BRANCH:
                        return 'Редактирование';
                    case COPY_BRANCH:
                        return 'Копирование';
                    case CREATE_BRANCH:
                        return 'Создание ветки';
                    default:
                        return 'Редактирование';
                }
            },
            branch: {
                get() {
                    return this.activeBranch
                },
                set(value) {
                    this.$store.commit('checkLists/setPersonalLists',  value)
                }
            },
        },
        data () {
            return {
                loading: false,
                values: [
                ],
                EDIT_BRANCH: EDIT_BRANCH,
                COPY_BRANCH: COPY_BRANCH
            }
        },
        methods: {
            ...mapMutations('checkLists', [
                'setControlsVisibility',
                'closeEdit',
                'setActiveList'
            ]),
            ...mapActions('checkLists', [
                'saveBranch',
                'pushBranch',
            ]),
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
                'setPopupData',

            ]),
            ...mapMutations('checkLists', [
                'setControlsVisibility',
                'closeEdit',
                'setActiveList',
                'copyListsToActiveBranch'
            ]),
            closeClick() {
                this.values = [];
                this.closeEdit();
            },
            saveClick() {
                if (!this.branch.title.length) {
                    this.$store.dispatch('pushNotification', {text: "Укажите название ветки", type: NOTIFICATION_WARNING, time: 3000});
                    return false
                }
                let lists = [];
                this.commonBranch.forEach((branch, i) => {
                    branch.lists.forEach((list, j) => {
                        if (this.values[i] && this.values[i][j] ) {
                            let newList = Object.assign({}, list);
                            newList.checked = true;
                            lists.push(newList)
                        }
                    })
                });
                this.copyListsToActiveBranch(lists);

                this.loading = true;
                if (this.controlType === EDIT_BRANCH) {
                    this.saveBranch().then(() => {
                        this.loading = false;
                        this.closeEdit();
                        this.values = [];
                    })
                } else {
                    this.pushBranch().then(() => {
                        this.loading = false;
                        this.closeEdit();
                        this.setPopupComponent(CompleteComponent);
                        this.setPopupData({msg: "Ветка чек-листов успешно создана!"});
                        this.switchPopup(true);
                        this.values = [];
                    })
                }
            },

        },
    }
</script>

<style scoped>

</style>
